import React from 'react';
import { clinicalAlertSeverityLabels } from '../clinical/clinicalAlerts';

const ClinicalAlertsPanel = ({ alerts = [], compact = false }) => (
  <div className={`clinical-alerts-panel ${compact ? 'clinical-alerts-panel-compact' : ''}`}>
    <div className="clinical-alerts-header">
      <div>
        <h3>Alertas clinicas</h3>
        <p>Alergias, condiciones prioritarias y riesgos antes de prescribir.</p>
      </div>
      <span>{alerts.length} alerta(s)</span>
    </div>

    {alerts.length === 0 ? (
      <p className="clinical-alerts-empty">Sin alertas clinicas detectadas con la informacion disponible.</p>
    ) : (
      <div className="clinical-alerts-list">
        {alerts.map((alert) => (
          <div key={alert.id} className={`clinical-alert clinical-alert-${alert.severity}`}>
            <div className="clinical-alert-title">
              <strong>{alert.title}</strong>
              <span>{clinicalAlertSeverityLabels[alert.severity] || alert.severity}</span>
            </div>
            <p>{alert.detail}</p>
            <small>{alert.action}</small>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default ClinicalAlertsPanel;
